import { createSlice } from '@reduxjs/toolkit';

export const ambassadorSlice = createSlice({
    name: 'ambassador',
    initialState: {
        data: null,
    },
    reducers: {
        setAmbassador: (state, { payload }) => {
            state.data = payload;
        },
    },
});

export const { setAmbassador } = ambassadorSlice.actions;

export default ambassadorSlice.reducer;
